import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSuccess } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/subscription/success-pass")({
  head: () => seoHead({
    title: "Payment Successful",
    description: "Your LeadXkids 3-day all-access pass is now active.",
    noindex: true,
  }),
  component: () => <SubscriptionSuccess variant="pass" />,
});
